<template>
    <div class="hide-fields-panel">
        <div class="panel-header">
            <h3>{{ $t("tables.hideFields") }}</h3>
            <a-icon type="close" @click="$emit('close')" />
        </div>
        <div class="panel-actions">
            <a-button @click="showAllFields">{{ $t("tables.showAll") }}</a-button>
            <a-button @click="hideAllFields">{{ $t("tables.hideAll") }}</a-button>
        </div>
        <a-input-search v-model="searchText" :placeholder="$t('tables.searchFields')" />
        <div class="fields-list">
            <div
                v-for="field in filteredFields"
                :key="field._id"
                class="field-item"
                @click="toggleField(field)"
            >
                <a-checkbox
                    :checked="!isFieldHidden(field._id)"
                    @change="toggleField(field)"
                    @click.native.stop
                />
                <i class="material-icons">{{ getIcon(field) }}</i>
                <span>{{ field.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "HideFields",
    props: {
        fields: {
            type: Array,
            required: true,
        },
        hiddenFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            searchText: "",
        };
    },
    computed: {
        filteredFields() {
            const lowerSearch = this.searchText.toLowerCase();
            return this.fields.filter((field) =>
                field.name.toLowerCase().includes(lowerSearch)
            );
        },
    },
    methods: {
        toggleField(field) {
            if (this.isFieldHidden(field._id)) {
                this.$emit("show-field", field._id);
            } else {
                this.$emit("hide-field", field._id);
            }
        },
        isFieldHidden(fieldId) {
            return this.hiddenFields.includes(fieldId);
        },
        getIcon(field) {
            if (field.icon) {
                return field.icon;
            }
            // İkon belirleme mantığı (field.fieldType'a göre)
            switch (field.fieldType) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                case "currency":
                    return "attach_money";
                case "datetime":
                    return "event";
                case "dropdown":
                    return "arrow_drop_down";
                case "checkbox":
                    return "check_box";
                case "url":
                    return "link";
                case "email":
                    return "email";
                case "phone":
                    return "phone";
                default:
                    return "help_outline";
            }
        },
        showAllFields() {
            this.$emit("show-all-fields");
        },
        hideAllFields() {
            this.$emit("hide-all-fields");
        },
    },
});
</script>

<style scoped lang="scss">
.hide-fields-panel {
    width: 300px;
    background-color: #fff;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: flex;
    flex-direction: column;

    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        h3 {
            margin: 0;
        }

        .anticon-close {
            cursor: pointer;
        }
    }

    .panel-actions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
    }

    .fields-list {
        flex-grow: 1;
        overflow-y: auto;

        .field-item {
            display: flex;
            align-items: center;
            padding: 8px;
            cursor: pointer;

            &:hover {
                background-color: #f5f5f5;
            }

            .ant-checkbox-wrapper {
                margin-right: 8px;
            }

            .material-icons {
                margin-right: 8px;
            }
        }
    }
}
</style>
